import { render, staticRenderFns } from "./ModalAdminAddPac.vue?vue&type=template&id=5199c50a&scoped=true"
import script from "./ModalAdminAddPac.vue?vue&type=script&lang=js"
export * from "./ModalAdminAddPac.vue?vue&type=script&lang=js"
import style0 from "./ModalAdminAddPac.vue?vue&type=style&index=0&id=5199c50a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199c50a",
  null
  
)

export default component.exports